import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";
import TableDecisionRules from "../Components/tableDecisionRules";
import InputFileHook from "../Components/inputFileHook";
import { API } from "aws-amplify";
import closeImg from "../Resources/svg/cancel.svg";
import ModalRetakeAsessory from './modalRetakeAsessory';

const modalConfigAS1 = ({ open,close,idConfig,typeFile='csv',type ='AS',title ='Reglas de Decisión',
subtitle ='Configura aquí las reglas de decisión para Ahorro Seguro'}) => {
  const { handleSubmit, register, reset } = useForm();
  const [ tableConfig, setTableConfig ] = useState([]);
  const [ openConf , setOpenConf] = useState(false);
  const [ fileName, setFileName ] = useState("Seleccione un archivo");
  const [fileData,setFileData] = useState(null);
  const [valuesFile,setValuesFile] = useState(null);
  const closeModal = () => {
    close(idConfig);
  };

  useEffect(() => {
    getDecisionRules();
  }, []);

  const onSubmit = (data) => {
    saveDecisionRules(data);
  };

  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  const getDecisionRules = async () => {
    if (typeFile === 'csv'){ 
      const response = await API.post("api-rentas", "/decision-rules2/"+ type, {
        body: {},
        headers: {}
      });
      setTableConfig(response.data);
    } else{
      const response = await API.get("api-rentas","/boletines");
      setTableConfig(response.data);
    }
  };

  const msgError = (msg) =>{
    toast.error(msg, {
      position: toast.POSITION.TOP_CENTER,
      className: "toast-modal"
    });
  };

  const saveCSV = async (metadata,request) =>{
    if (metadata.type !== 'application/vnd.ms-excel' && metadata.type !== 'text/csv') {
      msgError('Sólo se permite CSV.');
      return;
    }
    if (metadata.size > 5110000 ) {
      msgError('El archivo puede contener máximo 5MB.');
      return;
    }
    let response = await API.post("api-rentas", "/decision-rules", request);
    if (response.status !== 200) {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
        className: "toast-modal"
      });
    } else {
      toast.success(response.message, {
        position: toast.POSITION.TOP_CENTER,
        className: "toast-modal-success"
      });
      reset();
      setFileName("Seleccione un archivo");
      getDecisionRules();
    }
  };
  const savePdf = async (request)=>{
    let response = await API.post("api-rentas", "/boletines", request);
    if (response.status !== 200) {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
        className: "toast-modal"
      });
    } else {
      toast.success(response.message, {
        position: toast.POSITION.TOP_CENTER,
        className: "toast-modal-success"
      });
      reset();
      setFileName("Seleccione un archivo");
      getDecisionRules();
    }
  };
  const saveDecisionRules = async (values) => {
    const metadata = values.file[0];
    const fileBase64 = await fileToBase64(values.file[0]);
    setFileData(fileBase64);
    setValuesFile(values.file[0].name);
    const request = {
      body: {
        productType: type,
        fileName: values.file[0].name,
        fileEncoded: fileBase64.split(',')[1]
      }
    };
    if (typeFile === 'csv') {
      saveCSV(metadata,request);
    } else {
      if (metadata.type !== 'application/pdf'){
        msgError('Sólo se permite PDF.');
        return;
      }
      let filter = tableConfig.filter( (item) => item.name === values.file[0].name );
      if (filter.length > 0) {
        setOpenConf(true);
      } else {
        savePdf(request);
      }
    }
  };
  const handleClose = ()=>{
    setOpenConf(false);
  };

  const handleOpen = ()=>{
    const request = {
      body: {
        fileName: valuesFile,
        fileEncoded: fileData.split(',')[1]
      }
    };
    savePdf(request);
    setOpenConf(false);
  };

  return (
    <>
    <div className={`modalFormRG  ${open ? "is-open" : ""}`}>
      <div className="modalFormRG__container">
        <img
          src={closeImg}
          alt="imgClose"
          className="modalFormRG__container__button"
          onClick={closeModal}
        />
        <div className="configFormAS">
          <div className="configFormAS__container-titles">
            <p className="configFormAS__container-titles__title">
              Configuración <span>{title}</span>
            </p>
            <p className="configFormAS__container-titles__sub-title">
              {subtitle}
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="configFormAS__form">
            <label className="configFormAS__form__input-file">
              <InputFileHook name="file" accept={"." + typeFile} register={register} setFileName={setFileName}/>
              <span className="configFormAS__form__input-file__file-custom">{fileName}</span>
            </label>
            <div className="configFormAS__form__btn-container">
              <button
                id="button_quote_vas1"
                type="submit"
                className="configFormAS__form__btn-container__btn"
              >
                SUBIR ARCHIVO
              </button>
            </div>
          </form>
          <br/><br/>
          <hr/>
          <TableDecisionRules items={tableConfig} type={typeFile}></TableDecisionRules>
          <ToastContainer containerId={"A"} />
          <ModalRetakeAsessory
            open={openConf}
            setOpen={setOpenConf}
            title="¿Estas seguro?"
            subtitleMessage="Ya existe un archivo con el mismo nombre. ¿Desea reemplazarlo?"
            firstButtonText="CANCELAR"
            secondButtonText="CONFIRMAR"
            firstButtonFunction={handleClose}
            secondButtonFunction={handleOpen}
           />
        </div>
      </div>
    </div>
    </>
  );
};
export default modalConfigAS1;
